export default "__VITE_ASSET__CrwO3he4__"